module.exports = __webpack_public_path__ + "static/img/evidence4.f23490d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/evidence4.png
// module id = Oed5
// module chunks = 1 3